/* eslint-disable max-lines */
import moment from 'moment';
import _ from 'lodash';
import {ActionTypes} from '../actions';
import {Parameters} from '../../common/actionTypes';
import {printBinningLabels} from '../../common/util/print';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loadingInvoices': false,
  'listInvoices': [],
  'loadingBoxes': false,
  'listBoxes': [],
  'loadingInvoiceInfo': false,
  'loadingLinesStatus': false,
  'invoiceInfo': {},
  'totalStorageCars': 0,
  'listStorageCarsOpened': [],
  'listStorageCarsOccupied': [],
  'savingLineInfo': false,
};

const FORM_INITIAL_STATE = {
  'lastStorageCarSelected': '',
  'lastBoxSelected': '',
  'values': {
    'newItems': [],
  },
};

const modifyListStorageCars = (type, listStorageCars, {storageCar, action}) => {
  const newListStorageCars = [...listStorageCars];
  if (type === 'remove') {
    const index = newListStorageCars.indexOf(storageCar);
    if (index !== -1) {
      newListStorageCars.splice(index, 1);
    }
    return newListStorageCars;
  }
  
  if (newListStorageCars.indexOf(storageCar.toString()) === -1) {
    newListStorageCars.push(storageCar.toString());
  }
  return newListStorageCars;
};

const updateCheckedLinesInInvoiceInfo = (invoiceInfo, lineInfo) => {
  const infoUpdated = {...invoiceInfo};
  infoUpdated.invoiceLines = lineInfo.invoiceLines;
  infoUpdated.checkedLines = lineInfo.checkedLines;
  return infoUpdated;
};

const modifyListStorageCarOpenAfterSaveLine = (listStorageCarsOpened, lineInfo) => {
  const listStorageCars = [...listStorageCarsOpened];
  
  if (lineInfo.filledStorageCar) {
    const index = listStorageCars.indexOf(lineInfo.storageCar);
    if (index !== -1) {
      listStorageCars.splice(index, 1);
    }
    return listStorageCars;
  }

  const storageCarIsAlreadyOpen = _.includes(listStorageCars, lineInfo.storageCar);
  if (lineInfo.location === '1CAMBIO' || storageCarIsAlreadyOpen) {
    return listStorageCars;
  }
  const lineHasStock = _.filter(lineInfo.labels, {'labelType': 'STOCK'});
  if (!lineHasStock.length) {
    return listStorageCars;
  }
  listStorageCars.push(lineInfo.storageCar);
  return listStorageCars;
};

const modifyListStorageCarOccupeAfterSaveLine = (listStorageCarsOccupied, lineInfo) => {
  const newListStorageCars = [...listStorageCarsOccupied];
  if (!lineInfo.filledStorageCar) {
    return newListStorageCars;
  }
  if (newListStorageCars.indexOf(lineInfo.storageCar) === -1) {
    newListStorageCars.push(lineInfo.storageCar);
  }
  return newListStorageCars;
};

const getItemsWithLineInfo = (list, index, lineInfo) => {
  const newList = [...list];
  let newObject = {...newList[index]};
  const storageCar = newObject.storageCar;
  const date = newObject.date;
  newObject = lineInfo;
  newObject.storageCar = storageCar;
  newObject.date = date;
  newObject.boxChecked = true;
  newObject.partCodeCkecked = true;
  return [...list.slice(0, index), newObject, ...list.slice(index + 1)];
};

const getItemsWithoutLineInfo = (list, index) => {
  const newList = [...list];
  let newObject = {...newList[index]};
  const storageCar = newObject.storageCar;
  const date = newObject.date;
  const box = newObject.box;
  const partCode = newObject.partCode;
  newObject = {};
  newObject.storageCar = storageCar;
  newObject.date = date;
  newObject.box = box;
  newObject.partCode = partCode;
  newObject.boxChecked = true;
  newObject.partCodeCkecked = false;
  return [...list.slice(0, index), newObject, ...list.slice(index + 1)];
};

const updateLastStorageCarSelected = (lastStorageCarSelected, listItems, {index, lineInfo}) => {
  const listLines = [...listItems];
  const line = listLines[index];
  if (line.location === '1CAMBIO') {
    return lastStorageCarSelected;
  }
  const newStorageCarSelected = lineInfo.storageCar;
  return newStorageCarSelected;
};

const getItemsWithLabelsUpdated = (list, lineInfo, {index, lastStorageCar}) => {
  const newList = [...list];
  newList.push({'storageCar': lastStorageCar});

  const newObject = {...newList[index]};
  newObject.storageCar = newObject.location === '1CAMBIO' ? 'SC' : lineInfo.storageCar;
  newObject.labelsCount = lineInfo.labelsCount;
  newObject.labels = lineInfo.labels;
  newObject.itemSaved = true;
  printBinningLabels(lineInfo.labels);
  return [...newList.slice(0, index), newObject, ...newList.slice(index + 1)];
};

const emptyLineInfo = (newObject) => {
  newObject.partCodeCkecked = false;
  newObject.partCode = '';
  newObject.partName = '';
  newObject.location = '';
  newObject.stock = '';
  newObject.expectedQuantity = '';
  newObject.receivedQuantity = '';
  newObject.backOrders = '';
  newObject.labelsCount = '';
  newObject.checkedQuantity = '';
  return newObject;
};

const updateField = (list, index, fieldsToUpdate) => {
  const newList = [...list];
  const newObject = {
    ...newList[index],
    ...fieldsToUpdate,
  };
  return [...list.slice(0, index), newObject, ...list.slice(index + 1)];
};

const getItemsWithDate = (list, index, isInInvoice) => {
  const newList = [...list];
  let newObject = {...newList[index]};
  newObject.itemSaved = false;
  newObject.date = moment().toISOString();
  newObject.boxChecked = isInInvoice;
  if (!isInInvoice) {
    newObject = emptyLineInfo(newObject);
  }

  return [...list.slice(0, index), newObject, ...list.slice(index + 1)];
};

const getItemsWithLastCheckedBoxUpdated = (list, {index, lastCheckedBox}) => {
  const newList = [...list];
  const newObject = {...newList[index]};
  newObject.itemSaved = false;
  newObject.box = lastCheckedBox;
  newObject.boxChecked = true;
  
  return [...list.slice(0, index), newObject, ...list.slice(index + 1)];
};

export const checking = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_PENDING_INVOICES_TO_BIN]: (state, action) => ({
      ...state,
      'loadingInvoices': true,
    }),
    [ActionTypes.FETCHED_PENDING_INVOICES_TO_BIN]: (state, action) => ({
      ...state,
      'loadingInvoices': false,
      'listInvoices': action.response.data,
    }),
    [ActionTypes.FETCHED_PENDING_INVOICES_TO_BIN_FAILED]: (state, action) => ({
      ...state,
      'loadingInvoices': false,
      'listInvoices': [],
    }),
    [ActionTypes.FETCHING_BOXES_LIST_BY_INVOICE]: (state, action) => ({
      ...state,
      'loadingBoxes': true,
    }),
    [ActionTypes.FETCHED_BOXES_LIST_BY_INVOICE]: (state, action) => ({
      ...state,
      'loadingBoxes': false,
      'listBoxes': action.response.data,
    }),
    [ActionTypes.FETCHED_BOXES_LIST_BY_INVOICE_FAILED]: (state, action) => ({
      ...state,
      'loadingBoxes': false,
      'listBoxes': [],
    }),
    [ActionTypes.FETCHING_INVOICE_INFO]: (state, action) => ({
      ...state,
      'loadingInvoiceInfo': true,
    }),
    [ActionTypes.FETCHED_INVOICE_INFO]: (state, action) => ({
      ...state,
      'loadingInvoiceInfo': false,
      'invoiceInfo': action.response.data,
    }),
    [ActionTypes.FETCHED_INVOICE_INFO_FAILED]: (state, action) => ({
      ...state,
      'loadingInvoiceInfo': false,
      'invoiceInfo': {},
    }),
    [ActionTypes.FETCHING_INVOICE_LINES_CHECK_STATUS]: (state, action) => ({
      ...state,
      'loadingLinesStatus': true,
    }),
    [ActionTypes.FETCHED_INVOICE_LINES_CHECK_STATUS]: (state, action) => ({
      ...state,
      'loadingLinesStatus': false,
      'invoiceInfo': updateCheckedLinesInInvoiceInfo(state.invoiceInfo, action.response.data),
    }),
    [Parameters.FETCHED_SYSTEM_PARAMETER]: (state, action) => ({
      ...state,
      'totalStorageCars': action.response.data.value,
    }),
    [Parameters.FETCHED_SYSTEM_PARAMETER_FAILED]: (state, action) => ({
      ...state,
      'totalStorageCars': 0,
    }),
    [ActionTypes.FETCHED_STORAGE_CARS]: (state, action) => {
      if (action.payload === 'opened') {
        return ({
          ...state,
          'listStorageCarsOpened': action.response.data,
        });
      }
      return ({
        ...state,
        'listStorageCarsOccupied': action.response.data,
      });
    },
    [ActionTypes.FETCHED_STORAGE_CARS_FAILED]: (state, action) => {
      if (action.payload === 'opened') {
        return ({
          ...state,
          'listStorageCarsOpened': [],
        });
      }
      return ({
        ...state,
        'listStorageCarsOccupied': [],
      });
    },
    [ActionTypes.CHANGED_STORAGE_CAR_STATUS]: (state, action) => ({
      ...state,
      'listStorageCarsOpened': modifyListStorageCars('remove', state.listStorageCarsOpened, action.payload),
      'listStorageCarsOccupied': modifyListStorageCars('add', state.listStorageCarsOccupied, action.payload),
    }),
    [ActionTypes.EMPTY_INFO]: (state, action) => ({
      ...state,
      'listBoxes': [],
      'invoiceInfo': {},
      'listStorageCarsOpened': [],
      'listStorageCarsOccupied': [],
      'savingLineInfo': false,
    }),
    [ActionTypes.SAVING_INVOICE_LINE_INFO]: (state, action) => ({
      ...state,
      'savingLineInfo': true,
    }),
    [ActionTypes.SAVED_INVOICE_LINE_INFO]: (state, action) => {
      const lineInfo = action.response.data;
      return ({
        ...state,
        'savingLineInfo': false,
        'listStorageCarsOpened': modifyListStorageCarOpenAfterSaveLine(state.listStorageCarsOpened, lineInfo),
        'listStorageCarsOccupied': modifyListStorageCarOccupeAfterSaveLine(state.listStorageCarsOccupied, lineInfo),
      });
    },
    [ActionTypes.SAVED_INVOICE_LINE_INFO_FAILED]: (state, action) => {
      const error = action.error;
      const storageCar = action.payload;
      if (error.status === 422) {
        return ({
          ...state,
          'savingLineInfo': false,
          'listStorageCarsOpened': modifyListStorageCars('remove', state.listStorageCarsOpened, {storageCar}),
          'listStorageCarsOccupied': modifyListStorageCars('add', state.listStorageCarsOccupied, {storageCar}),
        });
      }
      
      return ({
        ...state,
        'savingLineInfo': false,
      });
    },
  })(state, action);
};

export const checkingForm = (state, action) => {
  return createReducer(FORM_INITIAL_STATE, {
    [ActionTypes.EMPTY_INFO]: (state, action) => ({
      ...state,
      'lastStorageCarSelected': '',
      'lastBoxSelected': '',
    }),
    [ActionTypes.VERIFIED_INVOICE_LINE_INFO]: (state, action) => ({
      ...state,
      'values': {
        ...state.values,
        'newItems': getItemsWithLineInfo(state.values.newItems, action.payload, action.response.data),
      },
    }),
    [ActionTypes.VERIFIED_INVOICE_LINE_INFO_FAILED]: (state, action) => ({
      ...state,
      'values': {
        ...state.values,
        'newItems': getItemsWithoutLineInfo(state.values.newItems, action.payload),
      },
    }),
    [ActionTypes.SAVED_INVOICE_LINE_INFO]: (state, action) => {
      const index = action.payload;
      const lineInfo = action.response.data;
      const lastStorageCar = updateLastStorageCarSelected(state.lastStorageCarSelected, state.values.newItems,
        {index, lineInfo});

      return ({
        ...state,
        'lastStorageCarSelected': lastStorageCar,
        'values': {
          ...state.values,
          'newItems': getItemsWithLabelsUpdated(state.values.newItems, lineInfo, {index, lastStorageCar}),
        },
      });
    },
    [ActionTypes.CLEAR_ITEMS]: (state, action) => ({
      ...state,
      'values': {
        ...state.values,
        'newItems': [{'date': null}],
      },
    }),
    [ActionTypes.VALIDATED_BOX_BELONG_INVOICE]: (state, action) => {
      const isInInvoice = action.response.data.isInInvoice;
      if (isInInvoice) {
        return ({
          ...state,
          'lastBoxSelected': action.payload.box,
          'values': {
            ...state.values,
            'newItems': getItemsWithDate(state.values.newItems, action.payload.index, isInInvoice),
          },
        });
      }
      return ({
        ...state,
        'values': {
          ...state.values,
          'newItems': getItemsWithDate(state.values.newItems, action.payload.index, isInInvoice),
        },
      });
    },
    [ActionTypes.SET_LAST_CHECKED_BOX]: (state, action) => ({
      ...state,
      'values': {
        ...state.values,
        'newItems': getItemsWithLastCheckedBoxUpdated(state.values.newItems, action.payload),
      },
    }),
    [ActionTypes.UPDATE_FIELDS_BINNING]: (state, action) => {
      const {index, fieldsToUpdate} = action.payload;
      return {
        ...state,
        'lastBoxSelected': action.payload.box,
        'values': {
          ...state.values,
          'newItems': updateField(state.values.newItems, index, fieldsToUpdate),
        },
      };
    },
  })(state, action);
};
